"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function HistoriaYFilosofia() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="historia-y-filosofía" className="relative bg-muted py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative z-10">
            <div ref={headingRef} className={`transition-all duration-700 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 leading-tight">
                Historia y Filosofía
              </h2>
            </div>

            <div ref={bodyRef} className={`lg:max-w-[65%] transition-all duration-700 ease-out delay-300 ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="text-foreground text-base md:text-lg leading-loose mb-6">
                Desde nuestros humildes comienzos, hemos cultivado una pasión
                inquebrantable por la excelencia culinaria y la hospitalidad
                auténtica.
              </p>

              <p className="text-foreground text-base md:text-lg leading-loose mb-6">
                Nuestra filosofía se basa en honrar las tradiciones
                mientras abrazamos la innovación.
              </p>

              <p className="text-foreground text-base md:text-lg leading-loose mb-6">
                Cada plato cuenta una historia, cada ingrediente es seleccionado
                con cuidado, y cada experiencia está diseñada para crear
                recuerdos duraderos.
              </p>

              <p className="text-foreground text-base md:text-lg leading-loose mb-6">
                Creemos que la comida no es solo sustento,
                sino una forma de arte que une a las personas.
              </p>

              <p className="text-muted-foreground text-base md:text-lg leading-loose mb-8">
                Nuestro compromiso con la calidad, la sostenibilidad y la
                comunidad define quiénes somos y hacia dónde nos dirigimos.
              </p>

              <blockquote className="border-l-4 border-accent pl-6 my-8">
                <p className="font-display italic text-2xl md:text-3xl text-secondary leading-tight">
                  “Cada plato es un puente entre nuestras raíces y el futuro.”
                </p>
              </blockquote>

              <div className="mt-8">
                <Button className="bg-transparent border-secondary text-secondary hover:bg-secondary-light hover:border-secondary-hover shadow-none border-md">
                  Ver Menú Completo
                </Button>
              </div>
            </div>

            <div className={`mt-12 transition-all duration-1000 ease-out delay-500 ${bodyVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"} origin-left`}>
              <svg width="200" height="40" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-accent-dark">
                <path d="M0 20C16.67 20 16.67 10 33.33 10C50 10 50 30 66.67 30C83.33 30 83.33 10 100 10C116.67 10 116.67 30 133.33 30C150 30 150 10 166.67 10C183.33 10 183.33 20 200 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
          </div>

          <div ref={imageRef} className="relative overflow-hidden rounded-lg group">
            <div className={`transition-all duration-1000 ease-out ${imageVisible ? "scale-100 opacity-100" : "scale-110 opacity-0"}`}>
              <div className="aspect-[4/5] relative overflow-hidden rounded-lg shadow-medium">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_architectural_interior.png" alt="Detalles arquitectónicos del restaurante" className="w-full h-full object-cover transition-all duration-500 ease-out group-hover:scale-105 group-hover:shadow-strong" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}